/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  GridC,
  MsgC,
  TextC,
} from 'lib';
*/
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as MsgC from "./_cccMsgC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

export const N = (pz: {
  sPz: ht.dz,
  cz: {
    i1zz: ht.dz,
  },
  boxStlz?: ht.boxStlz,
}) => {

  let _zone = '';
  let _nFeeTtl = 0;

//hf.l(`icvI1z___Tz 26: ${hf.s(pz.cz.i1zz.i1z3z)}`);
  const _genmenRitsu = 
    pz.cz.i1zz.i1z3z.i1z3m1110i > 0 ? 
      Number(pz.cz.i1zz.i1z3z.i1z3m2100i / pz.cz.i1zz.i1z3z.i1z3m1110i * 100) 
    : 0;
//hf.l(`icvI1z___Tz 31: ${_genmenRitsu}, ${pz.cz.i1zz.i1z3z.i1z3m2100i}, ${pz.cz.i1zz.i1z3z.i1z3m1110i}`);
  const _roomFeez = {} as ht.dz;
  pz.cz.i1zz.i1z1s.filter((_i1z1z: ht.dz) =>_i1z1z._dlt != 1).map((_i1z1z: ht.dz) => {
    if (hf.f(_zone)) _zone += `\n`;
    _zone += _i1z1z.i1z1a2200s; 
    if (!_roomFeez[_i1z1z.i1z1a2100s]) _roomFeez[_i1z1z.i1z1a2100s] = 0; 
    _roomFeez[_i1z1z.i1z1a2100s] += _i1z1z.i1z1m1100i;
    _nFeeTtl += _i1z1z.i1z1m1100i;
  });

  let _room = '';
  Object.keys(_roomFeez).map((_roomName: ht.s) => {
    if (hf.f(_room)) _room += `\n`;
    _room += `${_roomName}（${hf.cvtCmm(_roomFeez[_roomName])}円）`
  });
  if (_room == '') _room = '−';

  const _emtFeez = {} as ht.dz;
  pz.cz.i1zz.i1z2s.filter((_i1z2z: ht.dz) =>_i1z2z._dlt != 1).map((_i1z2z: ht.dz) => {
    if (!_emtFeez[_i1z2z.i1z2a2100s]) _emtFeez[_i1z2z.i1z2a2100s] = 0; 
    _emtFeez[_i1z2z.i1z2a2100s] += _i1z2z.i1z2m1100i;
    _nFeeTtl += _i1z2z.i1z2m1100i;
  });

  let _emt = ''; // equipment
  Object.keys(_emtFeez).map((_emtName: ht.s) => {
    if (hf.f(_emt)) _emt += `\n`;
    _emt += `${_emtName}（${hf.cvtCmm(_emtFeez[_emtName])}円）`
  });
  if (_emt == '') _emt = '−';

  return (

    cr.c(GridC.N, {
      key: -10,
      abtType: 'brdDntz',
      boxStlz: {
//        ... a(`dw/40 bc/${pz.sPz.crt.dffz.clr}5`),
        ... a(`dw/40`),
        ... pz.boxStlz,
      },
      lineCs: [
        {
//          boxStlz: a(`bc/${pz.sPz.crt.dffz.clr}5 sc/${pz.sPz.crt.dffz.clr}5`),
          boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}5`),
          cellCs: [
            {
              oClds: [
                cr.c(TextC.N, {
                  key: -10,
                  textz: {
                    pfx: `${pz.sPz.crt.dffz.tgt}内容`,
//                    stlz: a('tb ts/l'),
                    stlz: a('tb tc/lt1 ts/l'),
                  },
                })
              ]
            }
          ]
        },
        {
          //boxStlz: a(`sc/${pz.sPz.crt.dffz.clr}5`),
          boxStlz: a(`sc/lt1`),
          cellCs: [
            {
              //boxStlz: a(`sc/${_dffz.clr}5`),
              oClds: [

                cr.c(MsgC.N, {
                  key: -20,
                  abtType: 'cttz',
                  cz: {
                    ls: [
                      {
                        mkrCz: {
                          textz: {
                            pfx: '施設',
                          }
                        },
                        msgCz: {
                          textz: {
//                            pfx: '山内地区センター',
                            pfx: pz.sPz.crt._31rz?._pfx,
                          }
                        },
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '利用日',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: hfDTM.f(pz.cz.i1zz.i1zrz.i1zrd3100s, '年月日（曜）'),
                          }
                        },
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '利用時間帯',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: _zone,
                          }
                        },
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '部屋',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: _room,
                          }
                        },
                      },
                      {
                        mkrCz: {
                          textz: {
                            pfx: '備品・駐車場',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: _emt,
                          }
                        },
                      },
                      _genmenRitsu > 0 ?
                      {
                        mkrCz: {
                          textz: {
                            pfx: '減免率',
                            stlz: a(`tc/rd5`),
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: `${_genmenRitsu}%OFF`,
                            stlz: a(`tc/rd5`),
                          }
                        },
                      }
                      : undefined,
                      {
                        mkrCz: {
                          textz: {
                            pfx: '利用料金合計',
                          }
                        },
                        msgCz: {
                          textz: {
                            pfx: `${hf.cvtCmm(_nFeeTtl)}円`,
                          }
                        },
                      }
                    ],
                  },
                }),
              ]
            }
          ]
        }
      ]
    })

  );
};
